export default {
  errors: null,
  fitting_types: [],
  loading: false,
  count: 0,
  totalCount: 0
};
